import { render, staticRenderFns } from "./FrontpageLayout.vue?vue&type=template&id=73beb57d&"
import script from "./FrontpageLayout.vue?vue&type=script&lang=ts&"
export * from "./FrontpageLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports